import { render } from "./Department-details.vue?vue&type=template&id=dddee3c0&scoped=true"
import script from "./Department-details.vue?vue&type=script&lang=js"
export * from "./Department-details.vue?vue&type=script&lang=js"

import "./Department-details.vue?vue&type=style&index=0&id=dddee3c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dddee3c0"

export default script